<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("designation", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $tc("designation", 2) }}
          {{ $tc("incinematic") }}
        </div>
      </div>
      <div>
        <router-link
          v-if="$can('create', 'Designations')"
          variant="default"
          class="btn-blue"
          to="add-designation"
          >{{ $tc("add") }}</router-link
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 160px">
            <span class="pr-5">{{ $tc("status") }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'designation'"
              @click="onSortValue('designation', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('designation', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('designation', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("designation") }}
          </th>
        </tr>
      </thead>
      <tbody v-if="Designations.length > 0">
        <tr v-for="(item, key) in Designations" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  item.designation_is_active === 'Y' ? 'active' : 'inactive'
                "
              ></StatusDot>
              <div
                v-if="$can('update', 'Designations')"
                @click="goToRoute('/user-management/edit-designation', item)"
                class="btn-icon ml-2"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon" style="cursor: pointer"></i>
              </div>
              <div
                @click="goToRoute('/user-management/view-designation', item)"
                class="btn-icon ml-2"
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon" style="cursor: pointer"></i>
              </div>
              <div
                @click="onDeleteDesignation(item)"
                class="btn-icon ml-2"
                style="cursor: pointer"
                v-b-tooltip="'Delete'"
                tabindex="0"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="#8d6fbf"
                  class="bi bi-trash"
                  viewBox="0 0 18 18"
                >
                  <path
                    d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"
                  />
                  <path
                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6 a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"
                  />
                </svg>
              </div>
            </div>
          </td>

          <td>{{ $tc(item.designation, 1) }}</td>
        </tr>
      </tbody>
      <tbody v-if="Designations.length == 0">
        <td>{{ errors.message }}</td>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
  import languages from "@/helper/Languages";
  import i18n from "@/plugins/i18n";
  import MasterService from "@/services/MasterService";
  import Designations from "@/helper/formJSONMaster/Designations";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
  export default {
    components: {
      StatusDot,
      FilterByStatusDropdown,
    },
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",

        gridView: false,
        listView: true,
        Methods: Designations.Methods,
        Designations: [],
        customErrors: {
          message: "",
        },
        //sorting
        isSort: false,
        isAscending: false,
        columnName: "",
        orderBy: "",
      };
    },
    beforeMount() {
      this.getDesignationsList();
      this.getviewingnumber();
    },
    computed: {
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }

        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);

        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
    },

    methods: {
      onSortValue(columnName, orderBy) {
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderBy = orderBy;
        this.getDesignationsList();
      },
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },

      /* eslint-disable */
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.getDesignationsList();
        } else {
          this.currentPage = event;
          this.getDesignationsList();
        }
      },
      /* eslint-disable */
      goToRoute: function(path, item) {
        // edit-aggregator
        console.log("item :", item);
        const { designation_id } = item;
        this.$router.push({
          path: path,
          query: {
            id: designation_id,
          },
        });
      },
      onDeleteDesignation: function(item) {
        let loader = this.$loading.show();
        const { designation_id } = item;
        let payload = {
          id: designation_id,
        };
        MasterService.DeleteDesignationById(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .finally(() => {
            this.getDesignationsList();
            setTimeout(() => loader.hide(), 1000);
          });
      },
      getDesignationsList: function() {
        let payload = {
          tableName: "ms_designations",
          // designation_is_active: "Y",
          limit: this.perPage,
          currentPage: this.currentPage,
          columnName: this.columnName,
          orderBy: this.orderBy,
        };
        this.Designations = [];
        // let body = this.getRequestBody("GET", undefined, this.Methods);
        // body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}`;

        console.log("body :", payload);
        // MasterService.GlobalRequest(body)
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            console.log("response :", data);
            if (data.status) {
              if (data.Records.length > 0) {
                this.Designations = data.Records;
                if (data.totalRows >= 10) {
                  this.rows = data.totalRows;
                } else {
                  this.rows = data.totalRows;
                  this.selectedvalue = data.totalRows;
                }
              } else {
                this.customErrors.message = data.message;
              }
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },

      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
      // onClickEdit: function(){
      //   this.$router.push({ path: 'master/editaggregators' })
      // }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/DesignationsComponents/designations.vue